import { render, staticRenderFns } from "./IOTStatusPO.vue?vue&type=template&id=0c4d5604"
import script from "./IOTStatusPO.vue?vue&type=script&lang=js"
export * from "./IOTStatusPO.vue?vue&type=script&lang=js"
import style0 from "./IOTStatusPO.vue?vue&type=style&index=0&id=0c4d5604&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports